/** Whether a road contribution is updating an existing row via Enrich (not trace/draw). */
export function isRoadEnrichUpdate(
  featureTypeId: string | undefined,
  geometryMode: string | null | undefined,
  hasEnrichFeature: boolean,
  isEdit: boolean,
): boolean {
  return featureTypeId === 'road' && geometryMode === 'enrich' && hasEnrichFeature && !isEdit;
}

/**
 * Use enrichFeature geometry/extras only when the active flow is enrich.
 * Roads traced/drawn after switching away from enrich must not reuse a stale selection.
 */
export function shouldUseEnrichFeatureForContribution(
  featureTypeId: string | undefined,
  geometryMode: string | null | undefined,
  hasEnrichFeature: boolean,
): boolean {
  if (!hasEnrichFeature) return false;
  if (featureTypeId === 'road') return geometryMode === 'enrich';
  return true;
}
